import React, { useContext } from 'react';
import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';

import { OpeningWrapper } from '../../legacyCore/OpeningsCalendar';
import getTimeZoneFormat from '../utils/getTimeZoneFormat';
import { WIDGET_SCHEDULING } from '../constants';
import { buildOpeningUrl } from '../utils/urls';

import WidgetLink from './WidgetLink';
import { SchedulingSessionStateContext } from './SchedulingSessionState';
import toDate from '../utils/toDate';
import { formatOpeningTime } from '../utils/formatCalendarTime';

function CalendarOpening(props) {
  const { widgetSettings } = useContext(SchedulingSessionStateContext);
  const { opening, timeZone, match, location, history, staticContext, intl, ...linkProps } = props;

  const openingUrl = buildOpeningUrl(opening.provider.id, opening.id, {
    location: history.location,
  });

  const dateTime = toDate(opening.time);
  const timeZoneFormat = getTimeZoneFormat(timeZone);
  const toWidget = widgetSettings.scheduling === WIDGET_SCHEDULING.IN_WIDGET;

  return (
    <OpeningWrapper>
      <WidgetLink
        {...linkProps}
        href={openingUrl}
        toWidget={toWidget}
        data-qa="calendar-table__opening"
      >
        <time>{formatOpeningTime(dateTime, intl, timeZoneFormat)}</time>
      </WidgetLink>
    </OpeningWrapper>
  );
}

export default withRouter(injectIntl(CalendarOpening));
